/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import get from '@ion/core/src/environment/environment';
import {GenericObject} from '@ion/core/src/types/entities';
import {checkInheritableStatus} from '../editors/helpers';

interface UseHasInheritableProps {
  ancestorsGroups?: GenericObject;
  groupAccountId?: number;
  globalAccountId?: number;
  inheritable?: boolean;
};

/**
 * A simple hook returns `true` when child account able to see parent
 * account in the grid otherwise,, `false`.
 *
 * ```typescript
 *   import {useHasInheritable} from '@ion/dls/src/hooks/useHasInheritable';
 *
 *   const hasInheritable = useHasInheritable({
 *     accountsMap,
 *     groupAccountId,
 *     globalAccountId,
 *     inheritable
 *   });
 *
 * ```
 */
export const useHasInheritable = ({
  groupAccountId,
  globalAccountId,
  ancestorsGroups = [],
  inheritable = false
}: UseHasInheritableProps) => {
  const [inheritableStatus, setInheritableStatus] = useState(false);
  
  useEffect(() => {
    if (globalAccountId !== parseInt(get('rootAccountId'))) {
      setInheritableStatus(checkInheritableStatus({ancestorsGroups, groupAccountId}) && inheritable);
    }
  }, [globalAccountId, groupAccountId, inheritable, ancestorsGroups, checkInheritableStatus]);
  return inheritableStatus;
};

export default useHasInheritable;
